import styled from 'styled-components';

export const Logo = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 55px;
  justify-content: flex-end;
`;

export const LogoText = styled.span`
  ${({mini, theme}) => theme.font.default(mini? 13: 15, 1.1)};
  color: ${({isHome, theme}) => isHome? theme.color.standard: theme.color.primaryText};
  text-align: right;
  padding: 0 10px;
  opacity: 0.85;
`;

export const LogoImage = styled.img`
  height: auto;
  max-height: 100%;
  width: auto;
  max-width: auto;
`;


// WEBPACK FOOTER //
// ./src/components/Logo/style.js